// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"DeletePlaceholderEmbed__wrapper___3_0nB","name":"DeletePlaceholderEmbed__name___2n-C1","cancel":"DeletePlaceholderEmbed__cancel___2BwWT","cancelButton":"DeletePlaceholderEmbed__cancelButton___2_Yck"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DeletePlaceholderEmbed/DeletePlaceholderEmbed.scss
// module id = 1172
// module chunks = 1